import React from "react";
import {
  CssBaseline,
  GlobalStyles,
  LinearProgress,
  ThemeProvider,
  styled,
} from "@mui/material";
import useSettings from "app/hooks/useSettings";
import { Observer } from "mobx-react";
import appStore from "../../mobxStore/AppStore";

const TopLinearProgress = styled(LinearProgress)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  zIndex: theme.zIndex.appBar + 1,
  "& .MuiLinearProgress-bar": {
    backgroundColor: "#ffa726",
  },
}));

const MatxTheme = ({ children }) => {
  const { settings } = useSettings();
  let activeTheme = { ...settings.themes[settings.activeTheme] };

  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <GlobalStyles
        styles={(theme) => ({
          ":root": {
            "--matx-font-family": theme.typography.fontFamily,
            "--matx-palette-primary-main": theme.palette.primary.main,
            "--matx-palette-primary-contrastText":
              theme.palette.primary.contrastText,
            "--matx-palette-secondary-main": theme.palette.secondary.main,
            "--matx-palette-secondary-contrastText":
              theme.palette.secondary.contrastText,
            "--matx-palette-background-default": theme.palette.background.default,
            "--matx-palette-background-paper": theme.palette.background.paper,
            "--matx-palette-text-primary": theme.palette.text.primary,
            "--matx-palette-text-secondary": theme.palette.text.secondary,
            "--matx-palette-divider": theme.palette.divider,
          },
        })}
      />
      <Observer>{() => appStore.loading && <TopLinearProgress />}</Observer>
      {children}
    </ThemeProvider>
  );
};

export default MatxTheme;
